import theme from '../theme'
import { makeStyles } from '@material-ui/core'

export const styleOverride = makeStyles({
  root: {
    fontFamily: theme.typography.fontFamily,
    paddingBottom: '20px',
  },
  tableStyle: {
    borderSpacing: '0px 10px !important',
    borderCollapse: 'separate !important',
  },
  footerTable: {
    paddingTop: '20px',
    width: '100%',
    '& .spanTotalRows': {
      fontFamily: 'Barlow',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '17px',
      marginRight: '20px',
    },
    '& .selectPage': {
      height: '35px',
    },
    '& .MuiPagination-root': {
      float: 'right',
      '& .MuiPaginationItem-page.Mui-selected': {
        background: '#7D339D',
        borderRadius: '4px',
        color: 'white',
      }
    }
  }

})

export default styleOverride
